import { extendTheme } from "@mui/joy/styles";

// const typography = {
//     fontFamily: "Albert Sans",
//     h1: { fontFamily: "Albert Sans" },
//     h2: { fontFamily: "Albert Sans" },
//     h3: { fontFamily: "Albert Sans" },
//     h4: { fontFamily: "Albert Sans" },
//     h5: { fontFamily: "Albert Sans" },
//     h6: { fontFamily: "Albert Sans" },
//     body1: { fontFamily: "Albert Sans" },
//     body2: { fontFamily: "Albert Sans" },
//     caption: { fontFamily: "Albert Sans" },
//     button: { fontFamily: "Albert Sans" },
//     overline: { fontFamily: "Albert Sans" },
//     p: { fontFamily: "Albert Sans" },
//     label: { fontFamily: "Albert Sans" },
//     "body-md": { fontSize: "15px" },
// };

const typography = {
    fontFamily: "Outfit",
    h4: {
        fontFamily: "Outfit",
    },
};

const theme = extendTheme({
    cssVarPrefix: "standard",
    colorSchemes: {
        dark: {
            palette: {
                background: {
                    body: "#121212",
                    surface: "#1E1E1E",
                },
                text: {
                    primary: "#EAEAEA",
                    secondary: "#BBBBBB",
                },
            },
        },
    },
    // colorSchemes: {
    //     light: {
    //         palette: {
    //             primary: {
    //                 50: "#e8f3ec",
    //                 100: "#cfe9d9",
    //                 200: "#a2d4b1",
    //                 300: "#72be88",
    //                 400: "#4aa86a",
    //                 500: "#2f6e3b", // Base color
    //                 600: "#295f34",
    //                 700: "#224e2c",
    //                 800: "#1b3e24",
    //                 900: "#132f1b",
    //             },
    //             background: {
    //                 body: "#F5F5F5",
    //                 surface: "#FFFFFF",
    //             },
    //             text: {
    //                 primary: "#1f1f1f",
    //                 secondary: "#444",
    //             },
    //         },
    //     },
    //     dark: {
    //         palette: {
    //             primary: {
    //                 50: "#e0f2e7",
    //                 100: "#b8dfca",
    //                 200: "#90cca9",
    //                 300: "#67b888",
    //                 400: "#3fa466",
    //                 500: "#2f6e3b", // Base color
    //                 600: "#255b32",
    //                 700: "#1c4727",
    //                 800: "#14331d",
    //                 900: "#0d2213",
    //             },
    //             background: {
    //                 body: "#121212",
    //                 surface: "#1E1E1E",
    //             },
    //             text: {
    //                 primary: "#EAEAEA",
    //                 secondary: "#BBBBBB",
    //             },
    //         },
    //     },
    // },
    typography,
    radius: {
        xs: "10px",
        sm: "10px",
        md: "10px",
        lg: "10px",
        xl: "10px",
    },
});

export default theme;
